import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';

import CaretDown from "../../../assets/img/caret_down_grey.svg";
import Bekijk from '../../../assets/img/icons/bekijk.svg';
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import {renderMinistryFeedbackList} from "../../../helpers/feedbackHelpers";

class MinistryFeedbackStatus extends Component {
  static propTypes = {
    ministry: PropTypes.string.isRequired,
    showFeedback: PropTypes.bool,
  };

  static defaultProps = {
    showFeedback: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showFeedback: props.showFeedback,
      ministry: this.props.ministry
    };
    this.showFeedback = this.showFeedback.bind(this);
  }

  showFeedback() {
    this.setState(prevState => ({
      showFeedback: !prevState.showFeedback
    }))
  }

  render() {
    const { prevRoundFeedbackData} = this.props.feedback;
    const { gameState } = this.props;
    const {prevRoundSum} = gameState;
    if(!prevRoundSum) return null;

    let currentFeedback= [];

    if(!prevRoundFeedbackData) {
      return null;
    } else {
      prevRoundFeedbackData.find((item, i) => {
        if (item.Ministerie === this.props.ministry) {
          currentFeedback[i] = item;
          return true; // stop searching
        }
        return false;
      });
    }

    return (
      <div className={'feedback-status-container'}>
        <div className={'status-header'} onClick={this.showFeedback}>
          <div className={'title'}>
            <h3><img src={Bekijk} alt={'view'} className={'view-icon'}/> {__('sim_bekijk_ministerie_status')}</h3>
          </div>
          <img src={CaretDown} alt={'close'} className={'close-status' + (this.state.showFeedback ? ' rotate' : '')}/>
        </div>

        <div className={'feedback-container'  + (this.state.showFeedback ? ' show' : '')}>
          <div className='feedback-list'>
            {renderMinistryFeedbackList(this.props.feedback.prevRoundFeedbackData, this.props.ministry, this.props.gameState, this.props.gameStateInput) }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(({gameState, feedback, gameStateInput}) => ({gameState, feedback, gameStateInput}))(MinistryFeedbackStatus);



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/MinistryFeedbackStatus.js